import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Reason } from '../../interfaces/reason.interface';
import { CompanyService } from '../../services/company-service.service';

@Component({
    selector: 'app-deactivation-reason-modal',
    templateUrl: './deactivation-reason-modal.component.html',
})
export class DeactivationReasonModalComponent implements OnInit {
    form!: FormGroup;
    motivos: Reason[] = [];
    otroMotivoSeleccionado = false;
    isLoading = true;
    errorMessage = '';

    constructor(
        public activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private companyService: CompanyService
    ) {}

    async ngOnInit(): Promise<void> {
        this.form = this.fb.group({
            motivo: ['', Validators.required],
            otroMotivo: [''],
        });

        try {
            this.motivos = await this.companyService.getMotivosDesactivacion();
        } catch (error) {
            this.errorMessage = 'No se pudieron cargar los motivos.';
        } finally {
            this.isLoading = false;
        }

        this.form.get('motivo')?.valueChanges.subscribe((value) => {
            this.otroMotivoSeleccionado = value === 'otro';
            if (this.otroMotivoSeleccionado) {
                this.form
                    .get('otroMotivo')
                    ?.setValidators([
                        Validators.required,
                        Validators.minLength(3),
                    ]);
            } else {
                this.form.get('otroMotivo')?.clearValidators();
                this.form.get('otroMotivo')?.setValue('');
            }
            this.form.get('otroMotivo')?.updateValueAndValidity();
        });
    }

    confirmar() {
        if (this.form.invalid) return;

        const { motivo, otroMotivo } = this.form.value;

        this.activeModal.close({
            motivo: motivo === 'otro' ? null : motivo,
            otroMotivo: otroMotivo || null,
        });
    }

    cancelar() {
        this.activeModal.dismiss();
    }
}
